module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    ref: "textbox",
    class: {
      'compact-element': _vm.compact
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.label,
      "value": _vm.longFormat,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    on: {
      "change": _vm.changed
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da9a6ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/CurrencyBox.vue
// module id = 2515
// module chunks = 1